import { messages as countryNames } from 'shared/constants/countryNames';
import { ApiAmaxPayLegalEntityType } from 'shared/data/webApp/v2';

import { messages } from './PaymentDetailsBankAccountInfo.messages';
import { FieldItem } from './PaymentDetailsBankAccountInfo.types';

export const fields: FieldItem[] = [
    {
        title: messages.bankCountry,
        path: 'bankAccountDetails.bankAccount.countryIsoCode',
        getDisplayValue: (value) => {
            return countryNames[value as keyof typeof countryNames] || value;
        },
    },
    {
        title: messages.accountCurrency,
        path: 'bankAccountDetails.bankAccount.currencyIsoCode',
    },
    {
        title: messages.paymentMethod,
        path: 'payNetworkName',
    },
    {
        title: messages.entityType,
        path: 'bankAccountDetails.legalEntity.legalEntityType',
        getDisplayValue: (value) => {
            switch (value) {
                case ApiAmaxPayLegalEntityType.company:
                    return messages.company;
                case ApiAmaxPayLegalEntityType.individual:
                    return messages.individual;
                default:
                    return value;
            }
        },
    },
    {
        title: messages.bankAccountName,
        path: 'bankAccountDetails.bankAccount.bankAccountName',
    },
    {
        title: messages.accountNumber,
        path: 'bankAccountDetails.bankAccount.routing.bankAccountNumber',
    },
    {
        title: messages.bicSwift,
        path: 'bankAccountDetails.bankAccount.routing.bicSwift',
    },
    {
        title: messages.iban,
        path: 'bankAccountDetails.bankAccount.routing.iban',
    },
    {
        title: messages.address,
        path: 'bankAccountDetails.legalEntity.addressInfo.address',
    },
    {
        title: messages.city,
        path: 'bankAccountDetails.legalEntity.addressInfo.city',
    },
    {
        title: messages.country,
        path: 'bankAccountDetails.payerBankCountry',
        getDisplayValue: (value) => {
            return countryNames[value as keyof typeof countryNames] || value;
        },
    },
    {
        title: messages.postalCode,
        path: 'bankAccountDetails.legalEntity.addressInfo.postalCode',
    },
    {
        title: messages.stateOrProvince,
        path: 'bankAccountDetails.legalEntity.addressInfo.region',
    },
    {
        title: messages.companyName,
        path: 'bankAccountDetails.legalEntity.companyName',
    },
    {
        title: messages.firstName,
        path: 'bankAccountDetails.legalEntity.firstName',
    },
    {
        title: messages.lastName,
        path: 'bankAccountDetails.legalEntity.lastName',
    },
    {
        title: messages.sortCode,
        path: 'bankAccountDetails.bankAccount.routing.sortCode',
    },
    {
        title: messages.aba,
        path: 'bankAccountDetails.bankAccount.routing.aba',
    },
    {
        title: messages.bsb,
        path: 'bankAccountDetails.bankAccount.routing.bsb',
    },
    {
        title: messages.institutionNumber,
        path: 'bankAccountDetails.bankAccount.routing.institutionNumber',
    },
    {
        title: messages.incorporationNumber,
        path: 'bankAccountDetails.bankAccount.routing.incorporationNumber',
    },
    {
        title: messages.bankCode,
        path: 'bankAccountDetails.bankAccount.routing.bankCode',
    },
    {
        title: messages.branchCode,
        path: 'bankAccountDetails.bankAccount.routing.branchCode',
    },
    {
        title: messages.clabe,
        path: 'bankAccountDetails.bankAccount.routing.clabe',
    },
    {
        title: messages.cnaps,
        path: 'bankAccountDetails.bankAccount.routing.cnaps',
    },
    {
        title: messages.ifsc,
        path: 'bankAccountDetails.bankAccount.routing.ifsc',
    },
];
